import { z } from 'zod';

// Separado da página: o arquivo de rota entra no bundle de produção (routeTree) e não pode puxar os
// padrões da onda 2 para o JS inicial (a lição de /dev/patterns).

/** URL de /dev/record: a operação aberta (`?op=`) e a aba (`?tab=`, U42; a primeira não vai para a URL). */
export const recordSearch = z.object({
  op: z.string().min(1).optional().catch(undefined),
  tab: z.enum(['informacoes', 'envolvidos', 'credito', 'historico']).optional().catch(undefined),
});
